// extracted by mini-css-extract-plugin
export var dropdown = "_ej-0";
export var imagePlaceholder = "_ej-2";
export var imageWrapper = "_ej-3";
export var productImage = "_ej-1";
export var truncateContainer = "_ej-4";
export var truncateText = "_ej-5";